<template>
    <div>
        <vue-simple-context-menu element-id="myUniqueId" :options="getOptions(currentStatus)" ref="vueSimpleContextMenu"
            @option-clicked="optionClicked" @menu-closed="currentStatus = null" />
        <div class="orderGrid">
            <div class="order-grid col-sm-12 col-md-9 col-lg-9">
                <div class="header">
                    <h1 class="title">Orders</h1>
                </div>
                <div class="columntop">
                    <!--Start Colum-->
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-col">
                        <span id="col0" class="coltext">Medication/Procedure</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                        <span id="col1" class="coltext">Order Post Date</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                        <span id="col2" class="coltext">Order Post Time</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-col">
                        <span id="col2" class="coltext">Order Description</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                        <span id="col0" class="coltext">Status</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                        <span id="col0" class="coltext">Writer</span>
                    </div>
                    <!-- <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
            <span id="col3" class="coltext"></span>
          </div>
          <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
            <span id="col4" class="coltext"></span>
          </div>
          <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
            <span id="col4" class="coltext"></span>
          </div>
          <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
            <span id="col6" class="coltext"></span>
          </div>
          <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
            <span id="col7" class="coltext"></span>
          </div>
          <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
            <span id="col8" class="coltext"></span>
          </div> -->
                </div>
                <!--end Column top-->
                <template v-if="orders">
                    <div v-for="order in orders.slice().reverse()" :key="'order' + order.orderid" :class="'columnrow ' + order.status"
                        @contextmenu.prevent.stop="changeStatus($event, order)" @click="showOrder(order)">
                        <!--start column row-->
                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-row">
                            <span id="row" class="coltext">
                                <ul>
                                    <li v-for="(med, index) in orderItems[order.orderid]['medications']"
                                        :key="order.orderid + 'med' + index">
                                        {{ med.medname }}
                                    </li>
                                    <li v-for="(proc, index) in orderItems[order.orderid]['procedures']"
                                        :key="order.orderid + 'proc' + index">
                                        {{ proc.procedure_code }}
                                    </li>
                                </ul>
                            </span>
                        </div>
                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                            <span id="row" class="coltext">{{ order.orderdate }}</span>
                        </div>
                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                            <span id="row" class="coltext">{{ order.ordertime }}</span>
                        </div>
                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-row">
                            <span id="row" class="coltext">{{ stripHTML(order.orderdescription) }}</span>
                        </div>
                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                            <span id="row" class="coltext">{{ order.status }}</span>
                        </div>
                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                            <span id="row" class="coltext">{{ order.primary_physician }}</span>
                        </div>
                    </div>
                    <!--end Column Row-->
                </template>
            </div>
        </div>
        <div v-if="currentOrder" class="msorderwrapper" id="order__popup" style="display: flex">
            <div class="order-wrapper col-sm-12 col-lg-12">
                <div class="container">
                    <div class="col-sm-12 col-lg-12 opclosesec">
                        <span id="closeOrdermod">Order ID #{{ currentOrder.orderid }} For: <b>{{ patient.firstName + " " +
                            patient.lastName }}
                                ({{ patient.dob }})</b></span>
                        <h4></h4>
                    </div>
                    <!--end Paitent Form-->
                    <form :id="'orderform' + patient.id">
                        <div class="firstrow col-sm-12">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="orderdate" role="text">* Order Date</label>
                                <input type="date" required id="orderdate" class="datefield" name="date"
                                    :value="currentOrder.orderdate" disabled />
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="orderdate" role="text">* Order Time</label><br />
                                <input type="time" required id="ordertime" class="timefield" name="time"
                                    :value="currentOrder.ordertime" disabled />
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="ordertype" role="text">* Order Type</label><br />
                                <select required id="ordertype" class="ordertype" name="ordertype"
                                    v-model="currentOrder.ordertype" disabled>
                                    <!-- <option selected="select" value="">Select Order Type</option> -->
                                    <option value="Physicians Order">Physicians Order</option>
                                    <option value="Nurses Order">Nurses Order</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="abndelivered" role="text">
                                    ABN Delivered?</label>
                                <select required id="abntopatient" class="abntopatient" name="abn"
                                    v-model="currentOrder.abndelivery" disabled>
                                    <option selected value="0">N/A</option>
                                    <option value="1">Don't Know</option>
                                    <option value="2">Let's Try</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="phyAgentphy" role="text">
                                    Order Read Back To<br />Physican/Agent Of Physican</label>
                                <select required name="phyAgent" id="phyAgentphy" class="phyAgentphy"
                                    v-model="currentOrder.readorderback" disabled>
                                    <option selected value="NA">N/A</option>
                                    <option value="No">No</option>
                                    <option value="Yes">Yes</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12 secondrow">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="primphysician" role="text">* Primary Physican</label><br />
                                <input name="primphysician" type="text" required placeholder="" id="primphysician"
                                    style="z-index:9000;position:relative;" class="primphyfield"
                                    :value="currentOrder.primary_physician" disabled />
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="secphysician" role="text"> Secondary Physicians</label><br />
                                <input name="secphysician" type="text" id="secphysician" class="secphysician"
                                    :value="currentOrder.sec_physician" disabled />
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="email" role="text">E-mail</label><br />
                                <input name="email" type="text" id="email" class="email"
                                    :value="currentOrder.email" disabled />
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12 thirdrow">
                            <div class="col-sm-12 col-md-4 col-lg-3">
                                <label for="npinumber" role="text">* NPI Number</label><br />
                                <input name="npinumber" type="text" required id="npinumber" class="npifield" disabled
                                    :value="currentOrder.npinumber" />
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-3">
                                <label for="physaddress" role="text">* Address</label><br />
                                <input name="address" type="text" required id="physaddress" class="physaddressclass"
                                    :value="currentOrder.address" disabled />
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-3">
                                <label for="orderphonenumber" role="text">Order Phone Number</label><br />
                                <input name="orderphone" type="tel" id="orderphonenumber" class="orderphoneclass"
                                    :value="currentOrder.phone" disabled />
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-3">
                                <label for="orderfaxnumber" role="text">Order Fax Number</label><br />
                                <input name="orderfax" type="tel" id="orderfaxnumber" class="orderfaxclass" disabled
                                    :value="currentOrder.fax" />
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12 forthfrow">
                            <div class="col-sm-12 col-md-6 col-lg-6 orderaction">
                                <label>
                                    <input type="checkbox" id="sendtophysician" name="sendtophysician"
                                        value="Send To Physician" v-model="currentOrder.sendtophys" disabled />Send To
                                    Physicians</label>
                                <label>
                                    <input type="checkbox" name="woundcareorder" id="woundcare" value="Wound Care Order"
                                        v-model="currentOrder.woundcare" disabled />Wound
                                    Care Order</label><br />
                                <!-- <label>
                                    <input type="checkbox" id="verbalorder" name="verbalorder" value="Verbal Order"
                                        v-model="currentOrder.verbalorder" disabled />Verbal
                                    Order</label>
                                <input type="date" name="verbaldate" class="verbdatefield"
                                    v-model="currentOrder.verborder_date" disabled />
                                <input type="time" name="verbaltime" class="verbtimefield"
                                    v-model="currentOrder.verborder_time" disabled /> -->
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <div class="tabs col-sm-12 col-md-12 col-lg-12">
                                <div class="ordescriptab" :class="activeTab == 0 ? 'active' : ''">
                                    <a href="#orderscript" id="ordescripbtn" title="Order Description"
                                        @click="activeTab = 0">Order Description</a>
                                </div>
                                <div class="medicationtab" :class="activeTab == 1 ? 'active' : ''"
                                    :style="{ 'display': 'block' }">
                                    <a href="#medtab" id="medicationbtn" title="Medications Tab"
                                        @click="activeTab = 1">Medications</a>
                                </div>
                                <div class="diagnosistab" :class="activeTab == 2 ? 'active' : ''"
                                    :style="{ 'display': 'block' }">
                                    <a href="#diagnosistab" id="diagnosisbtn" title="Diagnosis Tab"
                                        @click="activeTab = 2">Diagnosis</a>
                                </div>
                                <div class="proctab" :class="activeTab == 3 ? 'active' : ''"
                                    :style="{ 'display': 'block' }">
                                    <a href="#proctab" id="procbtn" title="Procedure Tab"
                                        @click="activeTab = 3">Procedure</a>
                                </div>
                            </div>
                        </div>
                        <div id="ordercanvas" :style="[activeTab == 0 ? { 'display': 'block' } : { 'display': 'none' }]">
                            <editor disabled api-key="wtyerkxnsy7pxhf40g1mq9tjlifsy2ygztyau951df686zv9"
                                v-model="currentOrder.orderdescription" :init="{
                                    plugins: [
                                        'advlist',
                                        'autolink',
                                        'lists',
                                        'link',
                                        'image',
                                        'charmap',
                                        'preview',
                                        'anchor',
                                        'searchreplace',
                                        'visualblocks',
                                        'fullscreen',
                                        'insertdatetime',
                                        'media',
                                        'table',
                                        'help',
                                        'wordcount',
                                    ],
                                    toolbar:
                                        'undo redo | casechange blocks | bold italic backcolor | ' +
                                        'alignleft aligncenter alignright alignjustify | ' +
                                        'bullist numlist checklist outdent indent | removeformat | code table help',
                                }" /><br />
                            <!--<div class="col-sm-12 col-md-12 col-lg-12 ordclosebtn">
                                <input type="button" value="Cancel" id="cancelbtn" class="cancelbtn"/>
                                <input type="button" value="Save & Close" id="ordersavebtn" class="orderbtn"/>
                            </div>-->
                        </div>
                        <div id="medicationcanvas"
                            :style="[activeTab == 1 ? { 'display': 'block' } : { 'display': 'none' }]">
                            <div class="divider"></div>
                            <div class="mediationmodal col-sm-12 col-md-12 col-lg-12" :id="'mediationmodal' + patient.id">
                                <div class="modaltop">
                                    <section class="patienttopinfosec col-sm-12 col-md-6 col-lg-6">
                                        <div id="patientname">
                                            <p id="pname">{{ patient.firstName + " " + patient.lastName }}</p>
                                        </div>
                                        <div class="allergysec">
                                            <span>Allergies</span><br />
                                            <p></p>
                                        </div>
                                    </section>
                                    <section class="patientsecondinfosec col-sm-12 col-md-6 col-lg-6">
                                        <div id="patientbday">
                                            <p id="pday">{{ patient.dob }}</p>
                                        </div>
                                        <div class="attendphysician">
                                            <!-- <span>Attending Physician</span><br /> -->
                                            <!-- <p>Dr. Joseph Mulvehill</p> -->
                                        </div>
                                    </section>
                                </div>
                                <form :id="'dosesform' + patient.id" @submit.prevent="updateMed">
                                    <div class="mednamesec col-sm-12 col-lg-12">
                                        <input required name="medsearchbox" class="medsearchbox" type="search"
                                            :id="'medsearchbox' + patient.id" placeholder="Search for Medications"
                                            v-model="medicationSearchDescrip" @keyup.prevent="showMedSearch" />
                                        <div v-if="searchedMeds" :class="'searchresult' + patient.id" id="medsearchresult">
                                            <div v-for="med in searchedMeds" class="medlist" :key="med.rxcui"
                                                @click="clickMed(med)">
                                                <span id="rxcui">{{ med.rxcui }}</span>
                                                <p>{{ med.name }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modalbottom">
                                        <div class="medfirstSec col-sm-12 col-md-4 col-lg-4">
                                            <div class="flex-row">
                                                <select id="freqselect" name="freq" required>
                                                    <option selected="selected" value="Frequency">Frequency *</option>
                                                    <option value="1 Times Daily">1 Times Daily</option>
                                                    <option value="1 Times Weekly">1 Times Weekly</option>
                                                    <option value="2 Times Daily">2 Times Daily</option>
                                                    <option value="2 Times Weekly">2 Times Weekly</option>
                                                    <option value="3 Times Daily">3 Times Daily</option>
                                                    <option value="3 Times Weekly">3 Times Weekly</option>
                                                </select>
                                                <label><input name="PRN" type="checkbox" :id="'prncheckbox' + patient.id"
                                                        value="PRN" />
                                                    PRN</label>
                                            </div>
                                            <div class="flex-row">
                                                <input required type="text" placeholder="Reason *" name="reason"
                                                    id="medReason" v-model="diagSearchDescrip"
                                                    @keyup.prevent="showDiagSearch" />
                                                <div v-if="searchedDiags && searchedDiags.length != 0"
                                                    class="medDiagSearch">
                                                    <div v-for="diag in searchedDiags" class="medIcdli" :key="diag.code"
                                                        @click="clickDiag(diag)">
                                                        <span id="icdcode">{{ diag.code }}</span> - <span id="icddesript">{{
                                                            diag.description }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex-row">
                                                <input type="text" placeholder="Route" name="route" id="medRoute" />
                                            </div>
                                            <div class="flex-row">
                                                <select id="altrouteselect" name="altroute" required>
                                                    <option selected="selected" value="Frequency">Alternative Route*
                                                    </option>
                                                    <option value="1 daily">By Mouth</option>
                                                    <option value="2 daily">By Mouth Under Toungue</option>
                                                    <option value="3 daily">Cheek of Mouth</option>
                                                    <option value="2">Each Ear</option>
                                                    <option value="2">Each Eye</option>
                                                </select>
                                            </div>
                                            <div class="flex-row">
                                                <input type="text" placeholder="Instruction" name="instructions"
                                                    id="medInstructions" />
                                            </div>
                                        </div>
                                        <div class="medsecondSec col-sm-12 col-md-4 col-lg-4">
                                            <div class="flex-row medLabelGroup">
                                                <label class="medDateLabel">Start Date *</label><label
                                                    class="medDateLabel">End Date *</label>
                                            </div>
                                            <div class="flex-row">
                                                <input type="date" id="medStartdate" name="startDate" required />
                                                <input type="date" id="Medenddate" name="endDate" required />
                                            </div>
                                            <div class="flex-row">
                                                <select id="neworchange" name="neworchange">
                                                    <option selected="selected" value="Dose UOM">New/Change</option>
                                                    <option value="New">New</option>
                                                    <option value="Change">Change</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>
                                            <div class="flex-column">
                                                <input type="text" id="drugcategory" name="drug"
                                                    placeholder="Drug Classification" />
                                            </div>
                                        </div>
                                        <div class="medthirdSec col-sm-12 col-md-4 col-lg-4">
                                            <div class="flex-column medThirdCol">
                                                <label>Medication Understanding</label>
                                                <label><input name="understanding" type="radio"
                                                        id="meddirectionuse" />Direction for Use</label>
                                                <label><input name="understanding" type="radio"
                                                        id="Medpurpose" />Purpose</label>
                                                <label><input type="radio" id="MedSideffects" name="understanding" />Side
                                                    Effects/Interactions</label>
                                                <label><input name="understanding" type="radio" id="noUnder" />None</label>
                                            </div>
                                            <div class="flex-column medThirdCol">
                                                <label>Additional Settings</label>
                                                <label><input type="radio" id="agencyadmin" name="settings" />Agency
                                                    Administered</label>
                                                <label><input type="radio" id="highrisk" name="settings" />High Risk</label>
                                                <label><input type="radio" id="noSettings" name="settings" />None</label>
                                            </div>
                                            <div class="flex-column medThirdBtn">
                                                <input type="submit" id="savemedbtn" value="Save" />
                                                <input type="button" id="cancelmedbtn" @click="closeMed" value="Cancel" />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <!--Start Cuerrent Med Grid-->
                                <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                                    <div class="sortgrid">
                                        <label id="switchlbl">View Current Medications</label><label id="switch"><input
                                                type="checkbox" id="toggleSearch" />
                                            <span class="slider round"></span></label>
                                    </div>
                                    <!--end Column top-->
                                    <!--end Column Row-->
                                </div>
                                <!--End Med Grid-->
                            </div>
                            <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                                <div class="columntop">
                                    <!--Start Colum-->
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-6 top-col">
                                        <span id="col2" class="coltext">Medication</span>
                                    </div>
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                                        <span id="col3" class="coltext">Diagnosis</span>
                                    </div>
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                                        <span id="col4" class="coltext">Frequency</span>
                                    </div>
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                                        <span id="col4" class="coltext">Start</span>
                                    </div>
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                                        <span id="col6" class="coltext">End</span>
                                    </div>
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                                        <span id="col7" class="coltext">Route</span>
                                    </div>
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                                        <span id="col8" class="coltext">Alternative Route</span>
                                    </div>
                                </div>
                                <!--end Column top-->
                                <template v-if="orderItems[currentOrder.orderid]['medications']">
                                    <div v-for="med in orderItems[currentOrder.orderid]['medications']"
                                        :key="'med' + med.medentryid" class="columnrow" @click="showEditMed(med)">
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-6 top-row">
                                            <span id="row" class="coltext">{{ med.medname }}</span>
                                        </div>
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                                            <span id="row" class="coltext">{{ med.diagnose_code }}</span>
                                        </div>
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                                            <span id="row" class="coltext">{{ med.med_frequency }}</span>
                                        </div>
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                                            <span id="row" class="coltext">{{ med.med_startdate }}</span>
                                        </div>
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                                            <span id="row" class="coltext">{{ med.med_enddate }}</span>
                                        </div>
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                                            <span id="row" class="coltext">{{ med.route }}</span>
                                        </div>
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                                            <span id="row" class="coltext">{{ med.alt_route }}</span>
                                        </div>
                                    </div>
                                </template>
                                <!--end Column Row-->
                            </div>
                        </div>
                        <!--Diagnosis Canvas-->
                        <div id="diagnosiscanvas"
                            :style="[activeTab == 2 ? { 'display': 'block' } : { 'display': 'none' }]">
                            <div class="divider"></div>
                            <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                                <div class="columntop" id="diagColumnTop">
                                    <!--Start Colum-->
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-9 top-col">
                                        <span id="col3" class="coltext">Diagnosis Code</span>
                                    </div>
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                                        <span id="col4" class="coltext">Control System Rating</span>
                                    </div>
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                                        <span id="col7" class="coltext">Date</span>
                                    </div>
                                </div>
                                <template v-if="orderItems[currentOrder.orderid]['diagnosis']">
                                    <div v-for="(diag, index) in orderItems[currentOrder.orderid]['diagnosis']"
                                        :key="'diag' + diag.diagnosis_code + index" class="columnrow">
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-9 top-row">
                                            <span id="row" class="coltext">{{ diag.diagnosis_code }}</span>
                                        </div>
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                                            <span id="row" class="coltext">{{ diag.system_controlrating }}</span>
                                        </div>
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                                            <span id="row" class="coltext">{{ diag.diagnosis_date }}</span>
                                        </div>
                                    </div>
                                </template>
                                <!--end Column Row-->
                            </div>
                        </div>
                        <div id="diagnosiscanvas"
                            :style="[activeTab == 3 ? { 'display': 'block' } : { 'display': 'none' }]">
                            <div class="divider"></div>
                            <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                                <div class="columntop" id="diagColumnTop">
                                    <!--Start Colum-->
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-6 top-col">
                                        <span id="col3" class="coltext">Procedure</span>
                                    </div>
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                                        <span id="col4" class="coltext">Diagnosis</span>
                                    </div>
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                                        <span id="col4" class="coltext">Instruction</span>
                                    </div>
                                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                                        <span id="col7" class="coltext">Date</span>
                                    </div>
                                </div>
                                <!--end Column top-->
                                <template v-if="orderItems[currentOrder.orderid]['procedures']">
                                    <div v-for="(proc, index) in orderItems[currentOrder.orderid]['procedures']"
                                        :key="'diag' + index" class="columnrow">
                                        <!--start column row-->
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-6 top-row">
                                            <span id="row" class="coltext">{{ proc.procedure_code }}</span>
                                        </div>
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                                            <span id="row" class="coltext">{{ proc.diagnosis_code }}</span>
                                        </div>
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                                            <span id="row" class="coltext">{{ proc.instruction }}</span>
                                        </div>
                                        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                                            <span id="row" class="coltext">{{ proc.diagnosis_date }}</span>
                                        </div>
                                    </div>
                                </template>
                                <!--end Column Row-->
                            </div>
                        </div>
                        <!--end Diagnosis Canvas-->
                        <div class="col-sm-12 col-md-12 col-lg-12 ordclosebtn">
                            <input type="button" value="Close" id="cancelbtn" class="cancelbtn" @click="closeOrder" />
                        </div>
                    </form>
                </div>
                <!--endcontainer-->
            </div>
        </div>
    </div>
</template>

<script>
import { CURR_API, OTHER_API } from '@/constants/apis'
import { mapGetters, mapActions } from "vuex";
import axios from 'axios'
import Editor from "@tinymce/tinymce-vue";
import $ from 'jquery'

export default {
    name: "OrdersPage",
    data() {
        return {
            orders: null,
            orderItems: {},
            currentOrder: null,
            currentStatus: null,
            activeTab: 0,                 // Switch that focuses on right tab; 0 == order, 1 == medications, 2 == diagnosis, 3 == procedure
            // allMeds: null,
            // allDiags: null,
            // allProcs: null
            diagSearchCode: "",
            diagSearchDescrip: "", // ICD-10 search description (textfield) value
            searchedDiags: [], // List of ICD codes retrieved via icdSearch
            medicationSearchCode: "",
            medicationSearchDescrip: "", // Medication search description (textfield) value
            currentMedId: null,
            searchedMeds: [], // List of medications retrieved via medicationSearch
        };
    },
    components: {
        'editor': Editor,
    },
    async mounted() {
        this.getOrders()
            .then((res) => {
                if (res) {
                    res.forEach((order) => {
                        this.$set(this.orderItems, order.orderid, {})
                        this.loadMeds(order.orderid)
                        this.loadDiagsAndProcs(order.orderid)
                    })
                }
                // console.log(this.orderItems)
            })
    },
    computed: {
        ...mapGetters("login", {
            allData: "getAllData",
        }),
        patient: function () {
            return this.allData.patient;
        },
    },
    methods: {
        async updateMed() {
            let form = document.getElementById("dosesform" + this.patient.id);
            let content = {
                MedicationEdit: {
                    API_Meth: "UpdateMedication",
                    patientID: this.patient.externId,
                    medentryid: this.currentMedId,
                    ordernumber: this.currentOrder.orderid,
                    medname: this.medicationSearchDescrip,
                    doseamount: "", //form.elements['dosage'].value,
                    doseUOM: "", //form.elements['UOM'].value,
                    frequency: form.elements["freq"].value,
                    diagcode: form.elements["reason"].value,
                    medRoute: form.elements["route"].value,
                    altroute: form.elements["altroute"].value,
                    instruction: form.elements["instructions"].value,
                    medstrtdt: form.elements["startDate"].value,
                    medenddt: form.elements["endDate"].value,
                    changetype: form.elements["neworchange"].value,
                    durgclassification: form.elements["drug"].value,
                    prn: document.getElementById("prncheckbox" + this.patient.id).value,
                    directionuse: form.elements["understanding"].value,
                    additionalsettings: form.elements["settings"].value,
                    medstatus: "Active"
                },
            };
            await axios
                .post(CURR_API + "/tswebhook.php", content, {
                    headers: { "Content-Type": "application/json;" },
                })
                .then((res) => {
                    // console.log(res);
                    if (res.data.msg && res.data.msg == "Updated") {
                        this.medicationSearchCode = "";
                        this.medicationSearchDescrip = "";
                        this.diagSearchCode = "";
                        this.diagSearchDescrip = "";
                        this.currentMedId = null
                        this.loadMeds(this.currentOrder.orderid);
                        alert("Medication successfully updated");
                        document.getElementById(
                            "mediationmodal" + this.patient.id
                        ).style.display = "none";
                        $("#mediationmodal" + this.patient.id).css("display", "none");
                        // $(".modalbottom form").css("display","none");
                        // $(".mednamesec").css("display","none");
                        form.reset();
                    } else {
                        alert(
                            "Error with medication update. Try again or contact an administrator."
                        );
                    }
                });
        },
        showEditMed(med) {
            this.currentMedId = med.medentryid
            $("#mediationmodal" + this.patient.id).css("display", "flex");
            $("form .modalbottom").css("display", "flex");
            $("#dosesform" + this.patient.id).css("display", "block")
            let form = document.getElementById('dosesform' + this.patient.id)
            this.medicationSearchDescrip = med.medname
            this.diagSearchDescrip = med.diagnose_code
            document.querySelector('#dosesform' + this.patient.id + ' #medRoute').value = med.route
            document.querySelector('#dosesform' + this.patient.id + ' #altrouteselect').value = med.alt_route
            document.querySelector('#dosesform' + this.patient.id + ' #medStartdate').value = med.med_startdate
            document.querySelector('#dosesform' + this.patient.id + ' #freqselect').value = med.med_frequency
            document.querySelector('#dosesform' + this.patient.id + ' #medInstructions').value = med.instruction
            document.querySelector('#dosesform' + this.patient.id + ' #Medenddate').value = med.med_enddate
        },
        async showMedSearch() {
            if (this.medicationSearchDescrip == "") {
                this.searchedMeds = [];
                return;
            }
            let posturl =
                "https://rxnav.nlm.nih.gov/REST/drugs.json?name=" +
                this.medicationSearchDescrip;
            await axios.get(posturl).then((res) => {
                if (res.data.drugGroup.conceptGroup) {
                    for (let tty of res.data.drugGroup.conceptGroup) {
                        if (tty.conceptProperties) {
                            this.searchedMeds = this.searchedMeds.concat(
                                tty.conceptProperties
                            );
                        }
                    }
                } else {
                    this.searchedMeds = [];
                }
            });
        },
        clickMed(med) {
            this.medicationSearchCode = med.rxcui;
            this.medicationSearchDescrip = med.name;
            this.searchedMeds = [];
        },
        async showDiagSearch() {
            if (this.diagSearchDescrip == "") {
                this.searchedDiags = [];
                return;
            }
            if (true) {
                let content = {
                    action: "Search",
                    searchTerm: this.diagSearchDescrip,
                    ICDCode: "",
                    ICDReleaseUrl: "",
                };
                await axios
                    .post(CURR_API + "/icd_calls.php", content, {
                        headers: { "Content-Type": "application/json;" },
                    })
                    .then((res) => {
                        // console.log(res);
                        if (res.data.result == 0) {
                            this.searchedDiags = [];
                        } else {
                            this.searchedDiags = res.data.actualResults;
                        }
                    });
            }
        },
        clickDiag(diag) {
            this.diagSearchCode = diag.code;
            this.diagSearchDescrip = diag.code + " - " + diag.description;
            this.searchedDiags = [];
        },
        closeMed() {
            let doses = document.getElementById("dosesform" + this.patient.id);
            doses.reset();
            doses.style.display = "none";
            let form = document.getElementById("mediationmodal" + this.patient.id);
            form.style.display = "none";
            this.medicationSearchCode = "";
            this.medicationSearchDescrip = "";
            this.diagSearchCode = "";
            this.diagSearchDescrip = "";
            this.currentMedId = null
        },
        getOptions(status) {
            if (!status)
                return []
            switch (status.split(" ")[0]) {
                case "Active":
                    return [{ name: 'Hold' }, { name: 'Discontinue' }]
                case "Pending":
                    return [{ name: 'Activate' }, { name: 'Discontinue' }]
                case "Hold":
                    return [{ name: 'Reactivate' }, { name: 'Discontinue' }]
                case "Discontinued":
                    return [{ name: 'Reactivate' }]
                default:
                    return []
            }
        },
        changeStatus(event, item) {
            this.currentStatus = item.status
            this.$refs.vueSimpleContextMenu.showMenu(event, item)
        },
        async optionClicked(event) {
            let order = event.item
            let action = event.option.name

            if (action === "Activate" || action === "Reactivate")
                action = "Active (signed by " + this.allData.manager.name + ")"
            else if (action === "Discontinue")
                action = "Discontinued"
            let content = {
                "Orders": {
                    "API_Meth": "ChangeOrderStatus",
                    "ordernumber": order.orderid,
                    "status": action
                }
            }
            await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
                .then((res) => {
                    // console.log(res)
                    if (res.data.result && res.data.result === "Updated") {
                        alert("Order status updated.")
                        this.getOrders()
                    }
                    else {
                        alert("Error in updating order.")
                    }
                })
        },
        async getOrders() {
            let content = {
                "Orders": {
                    "API_Meth": "GetALLPatientOrders",
                    "patientID": this.patient.externId
                }
            }
            let ret = null
            await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
                .then((res) => {
                    if (res.data.Count > 0) {
                        ret = res.data.result
                        this.orders = ret
                    }
                    else {
                        this.orders = null
                    }
                    // console.log(res.data, this.orders)
                })
            return ret
        },
        async loadMeds(ordnum) {
            let content = {
                "MedGrid": {
                    "API_Meth": "PopulateMedGridByOrderID",
                    "pid": this.patient.externId,
                    "ordernumber": ordnum
                }
            }
            await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
                .then((res) => {
                    if (res.data.gridhtml) {
                        this.$set(this.orderItems[ordnum], 'medications', res.data.data)
                        // this.allMeds = res.data.data
                    }
                    else {
                        this.$set(this.orderItems[ordnum], 'medications', null)
                        // this.allMeds = null
                    }
                })
        },
        async loadDiagsAndProcs(ordnum) {
            let content = {
                "DiagGrid": {
                    "API_Meth": "PopulateDiagGridByOrderID",
                    "pid": this.patient.externId,
                    "ordernumber": ordnum
                }
            }
            await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
                .then((res) => {
                    if (res.data.gridhtml) {
                        let diags = res.data.data.filter(diag => diag.diagnosis_type === "Diagnosis")
                        let procs = res.data.data.filter(proc => proc.diagnosis_type === "Procedure")
                        this.$set(this.orderItems[ordnum], 'diagnosis', diags)
                        this.$set(this.orderItems[ordnum], 'procedures', procs)
                        // this.allDiags = res.data.data.filter(diag => diag.diagnosis_type === "Diagnosis")
                        // this.allProcs = res.data.data.filter(proc => proc.diagnosis_type === "Procedure")
                    }
                    else {
                        this.$set(this.orderItems[ordnum], 'diagnosis', null)
                        this.$set(this.orderItems[ordnum], 'procedures', null)
                        // this.allDiags = null
                        // this.allProcs = null
                    }
                })
        },
        showOrder(orderInfo) {
            // this.loadMeds(orderInfo.orderid)
            // this.loadDiagsAndProcs(orderInfo.orderid)
            this.currentOrder = orderInfo
        },
        closeOrder() {
            let order = document.getElementById("order__popup");
            order.style.display = "none";
            this.currentOrder = null
            this.allMeds = null
            this.allDiags = null
            this.allProcs = null
        },
        stripHTML(html) {
            let text = new DOMParser().parseFromString(html, 'text/html');
            return text.body.textContent || "";
        }
    },
};
</script>

<style>
/* @import "../../stylesheets/keyon"; */
.order-grid {
    margin: 0 auto;
}

.opclosesec {
    text-align: center;
}

.header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    color: #0060ff;
}

.title {
    margin-right: 20px;
}

.columnrow {
    background-color: unset;
}

ul {
    list-style-type: circle;
}

.Active {
    background-color: #0fae0f !important;
}

.Pending {
    background-color: #cece18 !important;
}

.Hold {
    background-color: #8e9faf !important;
}

.Discontinued {
    background-color: #d04c4c !important;
}
</style>